const unique = (item, pos, self) => {
    return self.indexOf(item) === pos;
};

export default unique;